import React, { useState } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { submitWaitlist } from '../../services/waitlistAPI'

const ModalComingSoon = ({ show, handleClose }) => {
    const [showPoll, setShowPoll] = useState(true)
    const [showWaitlist, setShowWaitlist] = useState(false)
    const [userType, setUserType] = useState('')
    const [email, setEmail] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)

    const handleUserTypeSelect = (type) => {
        setUserType(type)
        setShowPoll(false)
        setShowWaitlist(true)
    }

    const handleEmailSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)
        
        try {
            // Call the API service
            await submitWaitlist(email, userType)
            
            setIsSubmitted(true)
            setIsSubmitting(false)
        } catch (error) {
            console.error('Waitlist submission failed:', error)
            alert('Failed to join waitlist. Please try again.')
            setIsSubmitting(false)
        }
    }

    const resetModal = () => {
        setShowPoll(true)
        setShowWaitlist(false)
        setUserType('')
        setEmail('')
        setIsSubmitting(false)
        setIsSubmitted(false)
        handleClose()
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="modalTicket">
            <Modal.Body>
                <div className="text-center">
                    <div className="mb-4">
                        <div className="w-16 h-16 mx-auto bg-Myellow rounded-full flex items-center justify-center mb-4">
                            <span className="text-2xl">🚀</span>
                        </div>
                        <h3 className="font-medium text__24 text-Mblack mb-3">App Coming Soon!</h3>
                        <p className="text__16 text-[#525252] mb-6">
                            We're working hard to bring you the best homemade food marketplace experience. 
                            Our mobile app will be launching soon!
                        </p>
                        <p className="text__14 text-[#A3A3A3] mb-6">
                            In the meantime, tell us if you are interested as a buyer or seller!
                        </p>
                    </div>
                    
                    {/* Poll Section */}
                    {showPoll && (
                        <div className="mb-6">
                            <p className="text__16 font-medium text-Mblack mb-4">I'm interested as a:</p>
                            <div className="flex gap-3 justify-center">
                                <button 
                                    onClick={() => handleUserTypeSelect('buyer')}
                                    className="inline-block cursor-pointer text-center font-medium text__14 text-white bg-Mblack !py-[12px] !px-[24px] rounded-full hover:bg-[#2A2A2A] transition-colors"
                                >
                                    🛒 Buyer
                                </button>
                                <button 
                                    onClick={() => handleUserTypeSelect('seller')}
                                    className="inline-block cursor-pointer text-center font-medium text__14 text-white bg-Mblack !py-[12px] !px-[24px] rounded-full hover:bg-[#2A2A2A] transition-colors"
                                >
                                    👨‍🍳 Seller
                                </button>
                            </div>
                            <div className="mt-4">
                                <button 
                                    onClick={handleClose}
                                    className="text__14 text-[#A3A3A3] hover:text-Mblack cursor-pointer"
                                >
                                    Maybe later
                                </button>
                            </div>
                        </div>
                    )}
                    
                    {/* Waitlist Section */}
                    {showWaitlist && !isSubmitted && (
                        <div className="mb-6">
                            <h4 className="text__18 font-medium text-Mblack mb-3">
                                Join the {userType} waitlist! 🎉
                            </h4>
                            <p className="text__14 text-[#525252] mb-4">
                                We'll notify you as soon as the app launches.
                            </p>
                            <form onSubmit={handleEmailSubmit}>
                                <div className="mb-4">
                                    <Form.Control
                                        type="email"
                                        id="waitlist-email"
                                        name="waitlist-email"
                                        autoComplete="email"
                                        placeholder="Enter your email address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        disabled={isSubmitting}
                                        className="font-medium text__14 bg-[#FAFAFA] h-[48px] rounded-full px-4 outline-none shadow-none focus:outline-none focus:shadow-none border-[#E5E5E5] focus:border-Morange"
                                    />
                                </div>
                                <div className="flex gap-3 justify-center">
                                    <button 
                                        type="button"
                                        onClick={() => { setShowPoll(true); setShowWaitlist(false); }}
                                        className="inline-block cursor-pointer text-center font-medium text__14 text-Mblack bg-white border border-solid !border-[#E5E5E5] !py-[12px] !px-[20px] rounded-full hover:bg-[#F8F8F8]"
                                        disabled={isSubmitting}
                                    >
                                        ← Back
                                    </button>
                                    <button 
                                        type="submit"
                                        disabled={isSubmitting || !email}
                                        className="inline-block cursor-pointer text-center font-medium text__14 text-white bg-Morange !py-[12px] !px-[24px] rounded-full hover:bg-[#E66B00] disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {isSubmitting ? 'Joining...' : 'Join Waitlist'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    
                    {/* Success Section */}
                    {isSubmitted && (
                        <div className="mb-6 text-center">
                            <div className="w-12 h-12 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                                <span className="text-xl text-green-600">✓</span>
                            </div>
                            <h4 className="text__18 font-medium text-Mblack mb-2">
                                You're on the list!
                            </h4>
                            <p className="text__14 text-[#525252] mb-4">
                                We'll email you as soon as Pantria launches for {userType}s.
                            </p>
                            <button 
                                onClick={resetModal}
                                className="inline-block cursor-pointer text-center font-medium text__14 text-white bg-Morange !py-[12px] !px-[24px] rounded-full hover:bg-[#E66B00]"
                            >
                                Done
                            </button>
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalComingSoon